import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11, default as _styled12, default as _styled13, default as _styled14, default as _styled15, default as _styled16, default as _styled17, default as _styled18 } from "styled-components";
import React from "react";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { takeFirst } from "~/features/app/utils";
import { Media } from "~/features/ui/media";
import { Headline, parseTextWithHighlights } from "~/features/ui/headline";
import { Button } from "~/features/ui/button";
import { Link } from "~/features/ui/link";
import { VideoControls } from "~/features/ui/video/video-controls";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import { useLinkIcon } from "~/features/ui/link/use-link-icon";
import { isLinkValid } from "~/features/ui/link/utils";
const fragment = graphql(`
  fragment PageHero on hero_pageHero_BlockType {
    __typename
    headline: baseHeadline
    media: baseMedia {
      ...Media
    }
    caption: baseText
    layout: pageHeroLayout
    link: baseLink {
      ...Link
    }
  }
`);
const StyledBox = _styled.div.withConfig({
  componentId: "sc-sf-av0srl-0"
})`
  ${{
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "gap": "1.6rem"
}}
  ${{
  "borderTopWidth": "1px",
  "borderColor": "rgb(255 255 255 / 0.3)",
  "paddingLeft": "4rem",
  "paddingRight": "4rem",
  "paddingTop": "2.4rem",
  "paddingBottom": "2.4rem",
  "@media (min-width: 1024px)": {
    "width": "100%",
    "padding": "2.4rem",
    "paddingLeft": "8rem",
    "paddingRight": "8rem",
    "paddingTop": "4rem",
    "paddingBottom": "4rem"
  }
}}
`;
var _StyledStyledBox2 = _styled17(StyledBox).withConfig({
  componentId: "sc-sf-av0srl-1"
})({
  "@media (min-width: 1024px)": {
    "borderLeftWidth": "1px"
  }
});
var _StyledStyledBox = _styled15(StyledBox).withConfig({
  componentId: "sc-sf-av0srl-2"
})({
  "@media (min-width: 1024px)": {
    "justifyContent": "center"
  }
});
export function PageHero(props: FragmentType<typeof fragment>) {
  const {
    headline,
    media: _media,
    caption,
    link,
    layout = "default"
  } = useFragment(fragment, props);
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const media = takeFirst(_media);
  const isVideo = media && ("videoAsset" in media || "src" in media);
  const cta = takeFirst(link);
  const icon = useLinkIcon(cta);
  const isCentered = layout === "centered";
  const isDarkenedMedia = Boolean(media && "isDarkened" in media && media.isDarkened);
  return <_StyledDiv $_css={[{
    "borderTopWidth": "0px !important"
  }, {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  }, themeStyle.border]}>
      <_StyledDiv2>
        {!isDarkenedMedia && <_StyledDiv3 />}
        <_StyledDiv4>
          <Media {...media} imageProps={{
          fit: "cover",
          rounded: false,
          loading: "eager",
          priority: true
        }} inlineVideoProps={{
          fit: "cover",
          videoRef,
          rounded: false,
          priority: true
        }} externalVideoProps={{
          fit: "cover",
          rounded: false
        }} />
        </_StyledDiv4>
        <_StyledDiv5 $_css2={[{
        "display": "flex",
        "height": "100svh"
      }, isCentered ? {
        "alignItems": "center",
        "justifyContent": "center"
      } : {
        "alignItems": "flex-end"
      }]}>
          <_StyledDiv6 $_css3={[{
          "position": "relative",
          "zIndex": "10",
          "display": "flex",
          "width": "100%",
          "flexDirection": "column"
        }, isCentered ? {
          "alignItems": "center"
        } : {
          "alignItems": "flex-end"
        }]}>
            {isVideo && <_StyledDiv7 $_css4={[isCentered ? {
            "position": "absolute",
            "right": "0",
            "top": "0",
            "paddingRight": "1.6rem",
            "paddingTop": "1.2rem",
            "@media (min-width: 1024px)": {
              "paddingRight": "2.4rem",
              "paddingTop": "2.4rem"
            }
          } : {
            "paddingBottom": "1.2rem",
            "paddingRight": "1.6rem",
            "@media (min-width: 1024px)": {
              "paddingBottom": "2.4rem",
              "paddingRight": "2.4rem"
            }
          }]}>
                <VideoControls videoRef={videoRef} />
              </_StyledDiv7>}
            {isCentered ? <_StyledDiv8>
                {(caption || isLinkValid(cta)) && <_StyledDiv9>
                    {caption && <_StyledP>
                        {parseTextWithHighlights(caption)}
                      </_StyledP>}
                  </_StyledDiv9>}
                {headline && <_StyledDiv10>
                    <_StyledHeadline text={headline} />
                  </_StyledDiv10>}
                {isLinkValid(cta) && <Button as={Link} variant="secondary" {...cta} icon={icon} />}
              </_StyledDiv8> : <_StyledDiv11>
                {headline && <_StyledStyledBox>
                    <_StyledHeadline2 text={headline} />
                  </_StyledStyledBox>}
                {(caption || isLinkValid(cta)) && <_StyledStyledBox2>
                    {caption && <_StyledP2>{caption}</_StyledP2>}
                    {isLinkValid(cta) && <Button as={Link} variant="secondary" {...cta} icon={icon} />}
                  </_StyledStyledBox2>}
              </_StyledDiv11>}
          </_StyledDiv6>
        </_StyledDiv5>
      </_StyledDiv2>
    </_StyledDiv>;
}
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-av0srl-3"
})`${p => p.$_css}`;
var _StyledDiv2 = _styled3("div").withConfig({
  componentId: "sc-sf-av0srl-4"
})({
  "position": "relative",
  "zIndex": "10"
});
var _StyledDiv3 = _styled4("div").withConfig({
  componentId: "sc-sf-av0srl-5"
})({
  "pointerEvents": "none",
  "position": "absolute",
  "inset": "0",
  "zIndex": "10",
  "backgroundColor": "rgb(0 7 4 / 0.3)"
});
var _StyledDiv4 = _styled5("div").withConfig({
  componentId: "sc-sf-av0srl-6"
})({
  "position": "absolute",
  "inset": "0"
});
var _StyledDiv5 = _styled6("div").withConfig({
  componentId: "sc-sf-av0srl-7"
})`${p => p.$_css2}`;
var _StyledDiv6 = _styled7("div").withConfig({
  componentId: "sc-sf-av0srl-8"
})`${p => p.$_css3}`;
var _StyledDiv7 = _styled8("div").withConfig({
  componentId: "sc-sf-av0srl-9"
})`${p => p.$_css4}`;
var _StyledDiv8 = _styled9("div").withConfig({
  componentId: "sc-sf-av0srl-10"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "4rem",
  "paddingLeft": "4rem",
  "paddingRight": "4rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
});
var _StyledDiv9 = _styled10("div").withConfig({
  componentId: "sc-sf-av0srl-11"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "0.8rem"
});
var _StyledP = _styled11("p").withConfig({
  componentId: "sc-sf-av0srl-12"
})({
  "textAlign": "center",
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400",
  "textTransform": "uppercase",
  "--tw-text-opacity": "1",
  "color": "rgb(208 208 218 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.032rem",
    "fontWeight": "400"
  }
});
var _StyledDiv10 = _styled12("div").withConfig({
  componentId: "sc-sf-av0srl-13"
})({
  "maxWidth": "50ch",
  "textAlign": "center",
  "@media (min-width: 1024px)": {
    "maxWidth": "100ch"
  }
});
var _StyledHeadline = _styled13(Headline).withConfig({
  componentId: "sc-sf-av0srl-14"
})({
  "fontSize": "4.2rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "9.2rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.092rem",
    "fontWeight": "400"
  }
});
var _StyledDiv11 = _styled14("div").withConfig({
  componentId: "sc-sf-av0srl-15"
})({
  "width": "100%",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "display": "flex"
  }
});
var _StyledHeadline2 = _styled16(Headline).withConfig({
  componentId: "sc-sf-av0srl-16"
})({
  "fontSize": "2.4rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.8rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.038rem",
    "fontWeight": "400"
  }
});
var _StyledP2 = /*#__PURE__*/_styled18("p").withConfig({
  displayName: "page-hero___StyledP2",
  componentId: "sc-njk2l6-0"
})({
  "fontSize": "1.6rem",
  "lineHeight": "1.5",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "2.4rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.024rem",
    "fontWeight": "400"
  }
});